import * as React from "react"

export class Teaser extends React.Component<any> {
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row teaser-row">
                        <div className="mb-3 mb-md-0 col-12 col-md-4 d-flex align-items-center justify-content-center justify-content-md-end">
                            <img src="icons/elektronische-rechnungspflicht.png" alt="Elektronisce Rechnungspflicht" className="mw-100" />
                        </div>
                        <div className="col-12 col-md-8">
                            <p>
                                Überzeugen Sie sich selbst und testen Sie unseren XRechnungs-Generator <b>sofort</b> und vollkommen
                                <b> unverbindlich</b>. Erzeugen Sie gleich hier Ihre erste
                                <b> kostenlose Testrechnung</b> nach dem aktuellen Standard XRechnung 3.0.2 in der Syntax UBL.
                            </p>
                            <p>
                                Sie haben keine Lust, Testrechnungen selbst zu generieren? Registrieren Sie sich jetzt kostenfrei und lassen Sie sich
                                <b> 50 Testrechnungen</b> nach dem Standard XRechnung 3.0.2 im Format
                                <b> UBL</b> und <b>CII</b> per E-Mail liefern.
                            </p>
                            <p>
                                Es handelt sich hier um eine <b>Demoversion</b> des XRechnungs-Generators mit <b>eingeschränktem Funktionsumfang</b>. Für die
                                Vollversion nehmen Sie gerne mit uns Kontakt auf. Weitere Informationen zur Vollversion finden Sie unter{" "}
                                <a style={{ color: "#244b78" }} href="https://www.rechnungen-digitalisieren.de/xrechnungs-generator/">
                                    <b>XRechnungs-Generator</b>
                                </a>
                                .
                            </p>
                            <a href="https://www.rechnungen-digitalisieren.de/50-Testrechnungen" className="button button-primary">
                                Zur Registrierung
                            </a>
                        </div>
                    </div>
                </div>
                <h3>XRechnung generieren</h3>
            </div>
        )
    }
}
